import { render, staticRenderFns } from "./DetalleCompensacionModal.vue?vue&type=template&id=2dd38624"
import script from "./DetalleCompensacionModal.vue?vue&type=script&lang=js"
export * from "./DetalleCompensacionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd38624')) {
      api.createRecord('2dd38624', component.options)
    } else {
      api.reload('2dd38624', component.options)
    }
    module.hot.accept("./DetalleCompensacionModal.vue?vue&type=template&id=2dd38624", function () {
      api.rerender('2dd38624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DetalleCompensacionModal.vue"
export default component.exports